import { axios } from '@Root/API'

export const getContactStudentInfo = (id, type) => {
  return axios.get(`contact-student/name/${id}?type=${type}`)
}
